import { basicShareService } from "@/services/basicShare.service";
import { nguoiDungService } from "@/services/danhmuc/nguoiDung.service";
import ACTIONCODE from '@/config/actionCode.env';



const actions = {
    //Get Data
    async getBasicNguoiDung({ dispatch }, { params }) {
        params.ACTIONCODE = 31
        return await nguoiDungService.queryData(params).then(
            (resp) => {
                if (resp.statusCode == 200) {

                    return resp.data;
                }
                else {
                    dispatch("alert/warning", "Không tồn tại dữ liệu", { root: true });
                    return null;
                }
            },
            (error) => {
                console.log(error.message);
                dispatch("alert/error", "Có lỗi trong quá trình lấy dữ liệu", { root: true });
                return null;
            }
        );
    },
};


export const nguoiDung = {
    namespaced: true,
    actions,
};
